function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import React, { useContext, useEffect, useState } from "react";
import { ComboBox, SelectSkeleton } from "@carbon/react";
import { i18nContext, servicesContext } from "../../table-context";
import { format } from "../../../../utils/locales";
import propertyUtils from "../../../../utils/property-util";
import { APP_CONFIG_INTEGRATION, APP_CONFIG_SERVICEID } from "../../Constants";
var itemToString = function itemToString(item) {
  return item ? item.text : "";
};
export default function AppConfigIntegrationSelect(_ref) {
  var integrationProperty = _ref.integrationProperty,
    isLoading = _ref.isLoading,
    updateAppConfigProperty = _ref.updateAppConfigProperty;
  if (isLoading) {
    return /*#__PURE__*/React.createElement(SelectSkeleton, {
      className: "cds--form-item integration-select-skeleton",
      hideLabel: true
    });
  }
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var i18n = useContext(i18nContext);
  var toolchainServices = useContext(servicesContext);
  var findSelectedService = function findSelectedService(property) {
    var selected = null;
    if (property.value) {
      var selectedService = toolchainServices.find(function (item) {
        var _item$toolchain_bindi;
        return item.instance_id === property.value || ((_item$toolchain_bindi = item.toolchain_binding) === null || _item$toolchain_bindi === void 0 ? void 0 : _item$toolchain_bindi.name) === property.value;
      });
      selected = selectedService ? {
        id: selectedService.instance_id,
        text: propertyUtils.getIntegrationDisplayName(selectedService)
      } : {
        id: property.value,
        text: format(i18n.messages.integrationRemoved, [property.value])
      };
    }
    return selected;
  };
  useEffect(function () {
    if (!toolchainServices) {
      setItems([]);
    } else {
      var services = toolchainServices.filter(function (service) {
        return service.service_id === APP_CONFIG_SERVICEID;
      }).map(function (service) {
        return {
          id: service.instance_id,
          text: propertyUtils.getIntegrationDisplayName(service)
        };
      }).sort(function (a, b) {
        return a.text.localeCompare(b.text);
      });
      setItems(services);
      if (services && services.length === 1) {
        updateAppConfigProperty(APP_CONFIG_INTEGRATION, services[0].id);
      }
    }
  }, []);
  var selectedItem = null;
  if (integrationProperty && integrationProperty.value) {
    selectedItem = findSelectedService(integrationProperty);
  }
  var handleChange = function handleChange(event) {
    var _event$selectedItem;
    var value = ((_event$selectedItem = event.selectedItem) === null || _event$selectedItem === void 0 ? void 0 : _event$selectedItem.id) || "";
    updateAppConfigProperty(APP_CONFIG_INTEGRATION, value);
  };
  var translateIds = function translateIds(menuId) {
    var translations = {
      "close.menu": i18n.messages.menuClose,
      "open.menu": i18n.messages.menuOpen
    };
    return translations[menuId];
  };
  return /*#__PURE__*/React.createElement(ComboBox, {
    className: "ocr--property-select-dropdown",
    direction: "bottom",
    id: "property-panel-appconfig-integration",
    items: items,
    itemToString: itemToString,
    onChange: handleChange,
    placeholder: i18n.messages.propertyAppConfigSelect,
    selectedItem: selectedItem,
    titleText: i18n.messages.propertyAppConfig,
    translateWithId: translateIds
  });
}